import { VariantCharacters } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantCharacters.tsx';
import { VariantDate } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantDate.tsx';
import { VariantImage } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantImage.tsx';
import { VariantNakedImage } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantNakedImage';
import { VariantPoint } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantPoint.tsx';
import { VariantStar } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantStar.tsx';
import { VariantSizes } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import { VariantWrapText } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/VariantWrapText.tsx';
import styled, { CSSProperties } from 'styled-components';

interface VIImageProps {
    color: string;
    highlighted: boolean;
    title: string;
    size: VariantSizes;
    imageUrl: string;
    imageShowBg: boolean | null | undefined;
    imageShowContain?: boolean | null | undefined;
    eventDate?: string | null | undefined;
    sublabel?: string | null | undefined;
    style?: CSSProperties;
    className?: string;
}

export const VIImage = (props: VIImageProps) => {
    return (
        <S_VIImage className={props.className} style={props.style}>
            <S_WrapIcon>
                {props.size === 1 && (
                    <>
                        {!props.sublabel && <VariantPoint color={props.color} />}
                        {props.sublabel && <VariantCharacters characters={props.sublabel} />}
                    </>
                )}
                {(props.size === 2 || props.size === 3) && (
                    <>
                        {!props.imageShowBg && (
                            <>
                                <VariantNakedImage image={props.imageUrl} />
                                {props.sublabel && (
                                    <S_VariantCharacters characters={props.sublabel} />
                                )}
                                {props.highlighted && <S_VariantStar />}
                            </>
                        )}
                        {props.imageShowBg && (
                            <>
                                <VariantImage
                                    image={props.imageUrl}
                                    size={props.size === 2 ? 'small' : 'big'}
                                    contain={props.imageShowContain}
                                />

                                {props.sublabel && (
                                    <S_VariantCharacters characters={props.sublabel} />
                                )}
                                {props.highlighted && !props.eventDate && <S_VariantStar />}
                                {props.eventDate && (
                                    <S_VariantDate date={new Date(props.eventDate)} />
                                )}
                            </>
                        )}
                    </>
                )}
            </S_WrapIcon>
            {props.size === 3 && (
                <>
                    {props.imageShowBg && (
                        <S_VariantWrapText top={63} variantText={{ text: props.title }} />
                    )}
                    {!props.imageShowBg && (
                        <S_VariantWrapText top={50} variantText={{ text: props.title }} />
                    )}
                </>
            )}
        </S_VIImage>
    );
};

const S_VIImage = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: relative;
    width: 95px;
    height: 70px;
    justify-content: center;
    align-items: center;
    user-select: none;
`;

const S_WrapIcon = styled.div`
    position: relative;
    z-index: 1;
`;

const S_VariantStar = styled(VariantStar)`
    position: absolute;
    top: -7px;
    right: -7px;
`;

const S_VariantCharacters = styled(VariantCharacters)`
    position: absolute;
    top: -15px;
    left: -15px;
`;

const S_VariantWrapText = styled(VariantWrapText)`
    z-index: 2;
`;

const S_VariantDate = styled(VariantDate)`
    position: absolute;
    top: -15px;
    right: -15px;
`;
